export default class SoundOff {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.soundOff();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            default:
                event["soundOff"] = this._default
        }

        return event;
    }
}
